export default __webpack_public_path__ + "images/pages/quiz/categories/mobile_hair-504b82a7b1c19d2c7cd9eb402319ae6d.svg";